export default {
    videos: 'Videos',
    data_consumed: 'Verbrauchte Daten (mb)',
    size: 'Größe (Mb)',
    lms_link: 'LMS Link',
    video: 'Video',
    no_file: 'Es gibt keine Datei',
    text_upload_file: 'Beginnen Sie mit dem Hochladen einer neuen Datei.',
    upload: 'Hochladen',
}